<tc-master-operator-group
  *ngIf="settings"
  [settings]="settings"
  [addOperator$]="addNewOperator$"
></tc-master-operator-group>
